import React, { useState, useEffect } from 'react';
// import * as FaIcons from 'react-icons/fa';
// import * as AiIcons from 'react-icons/ai';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { SidebarData } from './SidebarData'
import './navbar.css';
import { useNavigate } from 'react-router';
function Navbar() {
  const [sidebar, setSidebar] = useState(false);
  const [num, setNum] = useState('')
  let type = localStorage.getItem('type');
  // var [clicked, setclicked] = useState(["nav-clicked","nav-text","nav-text","nav-text","nav-text"])
  let navigate = useNavigate();
  useEffect(async() => {
    let token = localStorage.getItem('access');
    window.addEventListener('popstate',onback)
    if (token) {
      var form_data = new FormData();
      form_data.append('token', token);
      await axios({
        method: "post",
        url: `${process.env.REACT_APP_API_URL1}/auth/jwt/verify`,
        data: form_data,
        headers: {
          "Content-Type": "multipart/form-data",
          'Authorization': `JWT ${localStorage.getItem('access')}`,
          'Accept': 'application/json'
        },
      }).then(response => {
        // console.log(div3.id)
        // setData(response.data)
        // navigate('/dashboard')
      }).catch(err => {
        // let notify = document.getElementsByClassName('noti')[0];
        // notify.innerHTML += `<div style="background-color:#f8d7da;color:#721c24" class='notifyUser'>
        //                 ${err.response.data.message}
        //             </div>`;
        // setTimeout(() => {
        //     notify.removeChild(notify.lastChild)
        // }, 3000);
        // console.log(err)
        navigate('/SignIn')
      })
    }
    var str = window.location.href;
    var res = str.split("/");
    setNum(res[(res.length) - 1])
    const fun = async () => {
      let apiRes = '';
      try {
        apiRes = await axios.get(`${process.env.REACT_APP_API_URL1}/project/currency/`);
        let dat = apiRes.data
        dat.INR = 1
        localStorage.setItem('currency', JSON.stringify(dat))
      } catch (err) {
        console.log(err.response.data);
        let dat = apiRes.data
        dat.INR = 1
        localStorage.setItem('currency', JSON.stringify(dat))
      } finally {
        console.log(apiRes);
      }
    };
    await fun()
    return () => {
        window.removeEventListener("popstate", onback);
    };
  }, [])
  function update() {
    var str = window.location.href;
    var res = str.split("/");
    setNum(res[(res.length) - 1])
  }
  function onback(){
    var str = window.location.href;
    var res = str.split("/");
    setNum(res[(res.length) - 1])
  }
  return (
    <>
      <nav className='dash-nav-menu nav-menu'>
        <ul className='nav-menu-items'>
          <li className='navbar-toggle'>
            {/* <svg onClick={() => setSidebar(false)} width="30" height="30" viewBox="0 0 30 30" fill="none">
              <circle cx="15" cy="15" r="14.75" fill="white" fill-opacity="1" stroke="#E5F4F1" stroke-width="0.5" />
              <path d="M9.74875 14.258C9.50784 14.4579 9.50784 14.8276 9.74875 15.0275L17.0373 21.0765C17.3631 21.347 17.8566 21.1152 17.8566 20.6918V8.59371C17.8566 8.17026 17.3631 7.93853 17.0373 8.20896L9.74875 14.258Z" fill="#000747" />
            </svg> */}
          </li>
          {SidebarData.map((item, index) => {
            return (
              <li onClick={() => update(item.path)} style={{ opacity: num.toLowerCase() == item.title.toLowerCase() ? '1' : '0.5' }} key={index} className={item.cName}>{/**on click */}
                <Link to={item.path}>
                  <img src={item.icon}></img>
                  <span>{item.title}</span>
                  {/* <div className='notification'></div> */}
                </Link>
              </li>
            )
          })}
          {type == 'ACCOUNTANT' || type == 'CONSULTANT' ? <li onClick={() => update('/Invoice')} style={{ opacity: num.toLowerCase() == 'Invoice'.toLowerCase() ? '1' : '0.5' }} key={5} className='nav-text'>{/**on click */}
            <Link to={'/Invoice'}>
              <img src={require('../IMAGES/Icons/VectorInvoice.png')}></img>
              <span>Invoice</span>
              {/* <div className='notification'></div> */}
            </Link>
          </li> : <></>}
          {type == 'HR' || type == 'CONSULTANT' ? <li onClick={() => update('/contracts')} style={{ opacity: num.toLowerCase() == 'Contracts'.toLowerCase() ? '1' : '0.5' }} key={5} className='nav-text'>{/**on click */}
            <Link to={'/contracts'}>
              <img src={require('../IMAGES/Icons/VectorContract.png')}></img>
              <span>Contracts</span>
              {/* <div className='notification'></div> */}
            </Link>
          </li> : <></>}
          {type == 'HR' || type == 'CONSULTANT' ? <li onClick={() => update('/agreements')} style={{ opacity: num.toLowerCase() == 'Agreements'.toLowerCase() ? '1' : '0.5' }} key={5} className='nav-text'>{/**on click */}
            <Link to={'/agreements'}>
              <i class="far fa-handshake"></i>
              <span>Agreements</span>
              {/* <div className='notification'></div> */}
            </Link>
          </li> : <></>}
          {type == 'HR' || type == 'PROJECT MANAGER' ? <li onClick={() => update('/users')} style={{ opacity: num.toLowerCase() == 'users'.toLowerCase() ? '1' : '0.5' }} key={5} className='nav-text'>{/**on click */}
            <Link to={'/users'}>
              <i class="fas fa-users"></i>
              <span>Users</span>
              {/* <div className='notification'></div> */}
            </Link>
          </li> : <></>}

          <footer className='cover'> . </footer>
        </ul>
      </nav>

    </>
  );
}

export default Navbar;







/*
consultant        :   project-view    ;  contract-view     ;   invoice-view,create ; agreement-view
hr                :   project-view    ;  user-view,type   ;  agreements-view,create ,contract-view,create
accountant        :   project-view    ;  invoice-view,stat
project manager   :   project-view,create   ;   users-view  
*/